module.exports = __webpack_public_path__ + "static/media/InfoCircle.e4c8ae6c.svg";